// Entry point for the build script in your package.json

import * as Tombolo from "tombolo";
import * as components from "./components";
Tombolo.start(components);
